import React, { useEffect, useState } from "react";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Components/Footer";
import Header from "../Components/Header";

const PublicacionesUsuario = () => {
  const [publicaciones, setPublicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch de datos desde el endpoint
  useEffect(() => {
    const fetchPublicaciones = async () => {
      try {
        const response = await fetch("https://sectorb12.info/api/publicaciones/");
        if (!response.ok) {
          throw new Error("Error al obtener las publicaciones");
        }
        const data = await response.json();
        setPublicaciones(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPublicaciones();
  }, []);

  return (
    <div className="d-flex flex-column">
      <Header></Header>
      <h4 className="mt-4 mb-2"><i className="bi bi-megaphone text-success"></i> Publicaciones Recientes</h4>
        <p className="text-muted mb-4">
        En esta sección puede realizar sus solicitudes a través de la Oficina Virtual.
      </p> 

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
          <p className="mt-3">Cargando publicaciones...</p>
        </div>
      ) : error ? (
        <p className="text-danger text-center">{error}</p>
      ) : publicaciones.length === 0 ? (
        <p className="text-center">No hay publicaciones disponibles.</p>
      ) : (
        <Row>
          {publicaciones.map((publicacion) => (
            <Col md={12} lg={12} key={publicacion.PublicacionID} className="mb-4">
              <Card className="shadow-sm h-100">
                <Card.Body>
                  <Card.Title className="text-success fs-6">
                    {publicacion.Titulo}
                  </Card.Title>
                  <Card.Text className="text-muted">
                    Publicado el{" "}
                    {new Date(publicacion.FechaPublicacion).toLocaleDateString()}
                  </Card.Text>
                  <Card.Text>{publicacion.Texto}</Card.Text>
                </Card.Body>
                {publicacion.Visibilidad ? (
                  <Card.Footer className="text-success">
                    <small>Visible para todos</small>
                  </Card.Footer>
                ) : (
                  <Card.Footer className="text-warning">
                    <small>Visible solo para usuarios seleccionados</small>
                  </Card.Footer>
                )}
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default PublicacionesUsuario;
